import { toast } from 'sonner';
import { surveysApi } from '@/api/surveys';
import { buildWhatsAppUrl } from '@/lib/whatsapp';
import { getSharableSurveyText } from '@/pages/surveys/utils/getSurveyText';

type ShareAction = 'copy' | 'whatsapp';

type ShareSurveyLinkParams = {
    patientId: string;
    assignmentId: string;
    action: ShareAction;
};

const buildExpiryText = (expiresAt?: string | null) => {
    if (!expiresAt) {
        return null;
    }

    const formattedDate = new Intl.DateTimeFormat('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(expiresAt));

    return `\nVálido até: ${formattedDate}`;
};

export const shareSurveyLink = async ({
    patientId,
    assignmentId,
    action,
}: ShareSurveyLinkParams) => {
    const toastId = toast.loading('Gerando link de acesso...');

    try {
        const response = await surveysApi.getAssignmentToken(patientId, assignmentId);
        const data = response?.data || response;
        const token = data?.unlock_token || data?.token;

        if (!token) {
            toast.error('Não foi possível recuperar o token de acesso.');
            return;
        }

        const link = `${window.location.origin}/patients/survey/answer?token=${token}`;

        if (action === 'copy') {
            await navigator.clipboard.writeText(link);
            toast.success('Link copiado para a área de transferência!');
            return;
        }

        let text = getSharableSurveyText(link);
        const expiryText = buildExpiryText(data?.unlock_token_expires_at);

        if (expiryText) {
            text += expiryText;
        }

        window.open(buildWhatsAppUrl(text), '_blank');
        toast.success('WhatsApp aberto!');
    } catch (error) {
        console.error(error);
        toast.error('Erro ao buscar o token de acesso.');
    } finally {
        toast.dismiss(toastId);
    }
};
